import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SvgSpriteV2Component } from 'src/app/pages/_components/svg-sprite-v2/svg-sprite-v2.component';

@Component({
  selector: 'app-portfolio-balls-navigation',
  templateUrl: './portfolio-balls-navigation.component.html',
  styleUrls: ['./portfolio-balls-navigation.component.scss'],
  imports: [
      CommonModule,
      SvgSpriteV2Component,
      RouterModule
    ],
})
export class PortfolioBallsNavigationComponent implements OnInit {

  @Input() pre = "../";
  @Input() post = "";
  @Input() prefix = "port";
  @Input() suffix = "ifa";
  @Output() change:EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }
  ballClick(event:any){   
    this.change.emit(event)
  }

}
